import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";

let currentAudio = null;
export default function AudioPlayer({ src }) {
  const audioRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    const audio = audioRef.current;

    if (!audio) return;

    if (currentAudio && currentAudio !== audio) {
      currentAudio.pause();
    }

    if (audio.paused) {
      audio.play();
      currentAudio = audio;
    } else {
      audio.pause();
      currentAudio = null;
    }

    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const audio = audioRef.current;
    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    audio.addEventListener("play", onPlay);
    audio.addEventListener("pause", onPause);
    return () => {
      audio.removeEventListener("play", onPlay);
      audio.removeEventListener("pause", onPause);
    };
  }, []);

  const updateProgress = () => {
    const audio = audioRef.current;
    if (!audio) return;

    setProgress(audio.currentTime);
  };

  const loadMetadata = () => {
    const audio = audioRef.current;
    if (!audio) return;

    setDuration(audio.duration);
  };

  const seek = (e) => {
    const audio = audioRef.current;
    const value = e.target.value;

    audio.currentTime = value;
    setProgress(value);
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600) || 0;
    const minutes = Math.floor((time % 3600) / 60) || 0;
    const seconds = Math.floor(time % 60) || 0;
    if (hours < 1) return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    else
      return `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className="player">
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={updateProgress}
        onLoadedMetadata={loadMetadata}
      />

      <button className="play-btn" onClick={togglePlay}>
        {isPlaying ? (
          <Icon
            icon="gravity-ui:pause-fill"
            className="icon"
            style={{ width: "28px", height: "28px" }}
          />
        ) : (
          <Icon
            icon="gravity-ui:play-fill"
            className="icon"
            style={{ width: "28px", height: "28px" }}
          />
        )}
      </button>

      <span className="time">{formatTime(progress)}</span>

      <input
        type="range"
        min="0"
        max={duration}
        value={progress}
        onChange={seek}
        className="progress"
      />

      <span className="time">{formatTime(duration)}</span>
    </div>
  );
}
